export default __webpack_public_path__ + "static/media/logistar.4e0a422c.png";